import { atom } from "jotai";

export type AuthenticationAtom =
  | {
      state: "authenticating";
    }
  | {
      state: "notConnected";
    }
  | {
      state: "connected";
    };

const authenticationAtom = atom<AuthenticationAtom>({
  state: "authenticating",
}); // By default the app start as "authenticating" meaning we don't know yet if user has a session or not.

export { authenticationAtom };
